var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilterList(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CD87525A-6A4E-4D0A-8610-B1822BBEBBC2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Components",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar",
    transform: "translate(-448.000000, -135.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "buttons/sidebar/collapse",
    transform: "translate(448.000000, 135.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,-1.13686838e-13 C6.71572875,-1.13686838e-13 -1.42108547e-14,6.71572875 -1.42108547e-14,15 C-1.42108547e-14,23.2842712 6.71572875,30 15,30 C23.2842712,30 30,23.2842712 30,15 C29.9758351,6.72575887 23.2742411,0.0241649367 15,-1.13686838e-13 Z",
    id: "Circle-Bg",
    fill: "#5C7284",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(7.000000, 8.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02712969,7 L17.0435589,7",
    id: "Line",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeWidth: 2,
    points: "8.50993565 13.954154 0.992331944 7 8.50993565 0.291919001"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilterList);
export default __webpack_public_path__ + "static/media/icon_filter_list.8b60fbad.svg";
export { ForwardRef as ReactComponent };